(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-timeline"] && !window.DesignMode) return;
  try {
    
	(function () {
		function VerticalTimeline(element) {
			this.element = element;
			this.blocks = this.element.getElementsByClassName('cd-timeline__block');
			this.images = this.element.getElementsByClassName('cd-timeline__img');
			this.contents = this.element.getElementsByClassName('cd-timeline__content');
			this.offset = 0.8;
			this.hideBlocks();
		}

		VerticalTimeline.prototype.hideBlocks = function () {
			if ((!'classList') in document.documentElement) {
				return; // no animation on older browsers
			}
			//hide timeline blocks which are outside the viewport
			var self = this;
			for (var i = 0; i < this.blocks.length; i++) {
				(function (i) {
					if (
						self.blocks[i].getBoundingClientRect().top >
						window.innerHeight * self.offset
					) {
						self.images[i].classList.add('cd-timeline__img--hidden');
						self.contents[i].classList.add('cd-timeline__content--hidden');
					}
				})(i);
			}
		};

		VerticalTimeline.prototype.showBlocks = function () {
			if ((!'classList') in document.documentElement) {
				return;
			}
			var self = this;
			for (var i = 0; i < this.blocks.length; i++) {
				(function (i) {
					if (
						self.contents[i].classList.contains('cd-timeline__content--hidden') &&
						self.blocks[i].getBoundingClientRect().top <=
							window.innerHeight * self.offset
					) {
						// add bounce-in animation
						self.images[i].classList.add('cd-timeline__img--bounce-in');
						self.contents[i].classList.add('cd-timeline__content--bounce-in');
						self.images[i].classList.remove('cd-timeline__img--hidden');
						self.contents[i].classList.remove('cd-timeline__content--hidden');
					}
				})(i);
			}
		};

		var verticalTimelines = document.getElementsByClassName('js-cd-timeline'),
			verticalTimelinesArray = [],
			scrolling = false;
		if (verticalTimelines.length > 0) {
			for (var i = 0; i < verticalTimelines.length; i++) {
				(function (i) {
					verticalTimelinesArray.push(new VerticalTimeline(verticalTimelines[i]));
				})(i);
			}

			//show timeline blocks on scrolling
			window.addEventListener('scroll', function (event) {
				if (!scrolling) {
					scrolling = true;
					!window.requestAnimationFrame
						? setTimeout(checkTimelineScroll, 250)
						: window.requestAnimationFrame(checkTimelineScroll);
				}
			});
		}

		function checkTimelineScroll() {
			verticalTimelinesArray.forEach(function (timeline) {
				timeline.showBlocks();
			});
			scrolling = false;
		}
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ethical-carousel"] && !window.DesignMode) return;
  try {
    
	const slider = document.querySelector('.materials_section');
	let mouseDown = false;
	let startX, scrollLeft;

	let startDragging = function (e) {
		mouseDown = true;
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	};
	let stopDragging = function (event) {
		mouseDown = false;
	};

	slider.addEventListener('mousemove', (e) => {
		e.preventDefault();
		if (!mouseDown) {
			return;
		}
		const x = e.pageX - slider.offsetLeft;
		const scroll = x - startX;
		slider.scrollLeft = scrollLeft - scroll;
	});

	// Add the event listeners
	slider.addEventListener('mousedown', startDragging, false);
	slider.addEventListener('mouseup', stopDragging, false);
	slider.addEventListener('mouseleave', stopDragging, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
        class StickyHeader extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.header = document.querySelector('.section-header') || document.querySelector('div[id^="shopify-section-sections"][id$="__header"]');
                this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
                    this.getAttribute('data-sticky-type') === 'reduce-logo-size';
                this.headerBounds = {};

                this.setHeaderHeight();

                window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

                if (this.headerIsAlwaysSticky) {
                    this.header.classList.add('shopify-section-header-sticky');
                }
                ;

                this.currentScrollTop = 0;
                this.preventReveal = false;
                this.predictiveSearch = this.querySelector('predictive-search');

                this.onScrollHandler = this.onScroll.bind(this);
                this.hideHeaderOnScrollUp = () => this.preventReveal = true;

                this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
                window.addEventListener('scroll', this.onScrollHandler, false);

                this.createObserver();
            }

            setHeaderHeight() {
                document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
            }

            disconnectedCallback() {
                this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
                window.removeEventListener('scroll', this.onScrollHandler);
            }

            createObserver() {
                let observer = new IntersectionObserver((entries, observer) => {
                    this.headerBounds = entries[0].intersectionRect;
                    observer.disconnect();
                });

                observer.observe(this.header);
            }

            onScroll() {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

                if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                    this.header.classList.add('scrolled-past-header');
                    if (this.preventHide) return;
                    requestAnimationFrame(this.hide.bind(this));
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                    this.header.classList.add('scrolled-past-header');
                    if (!this.preventReveal) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else {
                        window.clearTimeout(this.isScrolling);

                        this.isScrolling = setTimeout(() => {
                            this.preventReveal = false;
                        }, 66);

                        requestAnimationFrame(this.hide.bind(this));
                    }
                } else if (scrollTop <= this.headerBounds.top) {
                    this.header.classList.remove('scrolled-past-header');
                    requestAnimationFrame(this.reset.bind(this));
                }

                this.currentScrollTop = scrollTop;
            }

            hide() {
                if (this.headerIsAlwaysSticky) return;
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.closeMenuDisclosure();
                this.closeSearchModal();
            }

            reveal() {
                if (this.headerIsAlwaysSticky) return;
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }

            reset() {
                if (this.headerIsAlwaysSticky) return;
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            }

            closeMenuDisclosure() {
                this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
                this.disclosures.forEach(disclosure => disclosure.close());
            }

            closeSearchModal() {
                this.searchModal = this.searchModal || this.header.querySelector('details-modal');
                this.searchModal.close(false);
            }
        }

        customElements.define('sticky-header', StickyHeader);
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-tabs"] && !window.DesignMode) return;
  try {
    
	const tabs = {
		materials: {
			button: document.querySelector('#materials'),
			div: document.querySelector('.materials_tab'),
		},
		production: {
			button: document.querySelector('#production'),
			div: document.querySelector('.production_tab'),
		},
		'giving-back': {
			button: document.querySelector('#giving_back'),
			div: document.querySelector('.giving_back_tab'),
		},
		packaging: {
			button: document.querySelector('#packaging'),
			div: document.querySelector('.packaging_tab'),
		},
	};

	function changeTabSelected(selected, others) {
		selected.button.style.backgroundColor = '#BDBBA7';
		selected.div.style.display = 'flex';
		for (const other of others) {
			other.button.style.backgroundColor = '#EAEAE4';
			other.div.style.display = 'none';
		}
	}

	for (const key in tabs) {
		if (tabs.hasOwnProperty(key) && tabs[key].button) {
			tabs[key].button.addEventListener('click', (event) => {
				event.preventDefault();
				changeTabSelected(
					tabs[key],
					Object.keys(tabs)
						.filter((elem) => elem !== key)
						.map((otherKeys) => tabs[otherKeys]),
				);
			});
		}
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our_impact_materials_carousel"] && !window.DesignMode) return;
  try {
    
	const slider = document.querySelector('.materials_section');
	let mouseDown = false;
	let startX, scrollLeft;

	let startDragging = function (e) {
		mouseDown = true;
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	};
	let stopDragging = function (event) {
		mouseDown = false;
	};

	slider.addEventListener('mousemove', (e) => {
		e.preventDefault();
		if (!mouseDown) {
			return;
		}
		const x = e.pageX - slider.offsetLeft;
		const scroll = x - startX;
		slider.scrollLeft = scrollLeft - scroll;
	});

	// Add the event listeners
	slider.addEventListener('mousedown', startDragging, false);
	slider.addEventListener('mouseup', stopDragging, false);
	slider.addEventListener('mouseleave', stopDragging, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-group"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function (event) {
    var sl = document.querySelector('.js-slider-group');
    var slotGroupAmount = parseInt(sl.dataset.groupamount, 10);
    if (sl != null) {
      new Flickity(sl, {
        prevNextButtons: false,
        pageDots: true,
        setGallerySize: true,
        wrapAround: true,
        groupCells: slotGroupAmount,
        initialIndex: 2,
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
